var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H37.9973C43.5202 0 47.9973 4.47715 47.9973 10V37.9973C47.9973 43.5202 43.5202 47.9973 37.9973 47.9973H10C4.47715 47.9973 0 43.5202 0 37.9973V10Z",
    fill: "#D0438D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9917 14.0028V18.0012",
    stroke: "white",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9883 14.0028V18.0012",
    stroke: "white",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9871 16.002H16.9929C15.8888 16.002 14.9937 16.8971 14.9937 18.0012V31.9953C14.9937 33.0994 15.8888 33.9945 16.9929 33.9945H30.9871C32.0912 33.9945 32.9862 33.0994 32.9862 31.9953V18.0012C32.9862 16.8971 32.0912 16.002 30.9871 16.002Z",
    stroke: "white",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9937 21.9995H32.9862",
    stroke: "white",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/Events.feb2002dc2d87bee110e9d9881eab187.svg";
export { ForwardRef as ReactComponent };